import token from "@/services/util/roleHandler";

export const hasFeature = (featureName) => token.getFeatures().includes(featureName);

export default { hasFeature };